import React from 'react'

import FaqItem from '~/components/FaqItem'

export default class FaqBlock extends React.Component {

  render () {
    const { faqObject, openQuestionIndex, t } = this.props
    const categories = Object.keys(faqObject)

    return (
      <div className='faq-block'>
        {categories.map((category, categoryId) => (
          <section
            className='faq-block__section'
            key={category}
            id={category}
          >
            <h3
              className='faq-block__heading'
              dangerouslySetInnerHTML={{ __html: faqObject[category].heading }}
            />
            {faqObject[category].qna && (faqObject[category].qna).map((query, queryId) => (
              <FaqItem
                key={queryId}
                question={query.question}
                answer={query.answer}
                queryId={queryId}
                categoryId={categoryId}
                openQuestionIndex={openQuestionIndex}
                t={t}
              />
            ))}
          </section>
        ))}
      </div>
    )
  }
}
